import { Slider } from "..";
import * as S from "./styles";

const mountImages = (IMAGE: string, LINK?: string): any => ({
  IMAGE,
  LINK,
});

const ProductGallery = ({ image }: any) => {
  return (
    <S.ProductGalleryWrapper>
      {image && (
        <Slider
          dots
          canSwipe
          isGallery
          autoplay={false}
          slidesToShow={1}
          id="main-gallery"
          slides={[mountImages(`${image}`)]}
          openFullScreen={() => {}}
          closeFullScreen={() => {}}
        />
      )}
    </S.ProductGalleryWrapper>
  );
};

export default ProductGallery;
